import * as z from 'zod/mini';
export const Id = z.union([
    z.pipe(z.string(), z.transform((v) => BigInt(v))),
    z.bigint(),
]);
//# sourceMappingURL=Id.js.map